// Copyright (c) Ensho Health, 2021 to present

const base64UrlChars =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';

function b16to64url(h) {
  let i;
  let c;
  let ret = '';
  if (h.length % 2 === 1) {
    h = `0${h}`;
  }
  for (i = 0; i + 3 <= h.length; i += 3) {
    c = parseInt(h.substring(i, i + 3), 16);
    ret += base64UrlChars.charAt(c >> 6) + base64UrlChars.charAt(c & 63);
  }
  if (i + 1 === h.length) {
    c = parseInt(h.substring(i, i + 1), 16);
    ret += base64UrlChars.charAt(c << 2);
  } else if (i + 2 === h.length) {
    c = parseInt(h.substring(i, i + 2), 16);
    ret += base64UrlChars.charAt(c >> 2) + base64UrlChars.charAt((c & 3) << 4);
  }
  return ret;
}

export default b16to64url;
